<template>
    <v-dialog
        v-model="state.isVisible"
        scrollable
        lazy
        absolute
        content-class="large">
        <sponsor-dialog-content
            v-if="state.isVisible"
            :close-call-back="closeDialog"
            :sponsors="$attrs.sponsors"
            :saveactionname="$attrs.saveactionname"
            :communityId="$route.params.communityId"
            :saveactionmodulename="$attrs.saveactionmodulename"></sponsor-dialog-content>
    </v-dialog>
</template>

<script>
    import SponsorDialogContent from "./SponsorDialogContent.vue";

    export default {
        name: 'SponsorDialog',
        components: {
            SponsorDialogContent,
        },
        props: {
            state: {
                type: Object,
                default: () => ({}),
            },
        },
        methods: {
            closeDialog() {
                this.state.isVisible = false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .item-border {
        border: 1px solid $ypo-gray !important;
        border-radius: 10px;
        width: 100%;
        height: 100%;
    }

    .responsive {
        width: 125px;
        height: 125px;
    }

    .sponsor__layoutview {
        border: none;
        width: 1300px;
        overflow-y: scroll;
        text-align: center;
    }

    .sponsor-dialog {
        &__add-button {
            margin-left: 60px;
            width: 125px;
            height: 125px;
            margin-top: 30px;
        }

        &__cont {
            @include breakpoint(md) {
                display: block;

                .sponsor__layoutview {
                    width: 100%;
                    overflow: inherit;
                }

                &__btn {
                    .sponsor-dialog__add-button {
                        width: auto;
                        height: auto;
                        padding: 5px 10px;
                        margin: 0 30px;
                        background: $ypo-blue !important;

                        i {
                            font-size: 40px !important;
                            color: $white !important;
                        }
                    }
                }
            }

            @include breakpoint(xs) {
                .sponsor__layoutview {
                    width: inherit;
                }

                .vue-grid-layout {
                    width: 1300px;
                }

                &__btn {
                    .sponsor-dialog__add-button {
                        i {
                            font-size: 34px !important;
                        }
                    }
                }
            }
        }

        &__close-btn .v-icon {
            min-height: 30px !important;
            min-width: 30px !important;
            font-weight: bold !important;
        }

        &__apply_btn {
            border: 1px solid $ypo-gray !important;
            border-radius: 4px;
            background-color: $ypo-title-blue !important;
            font-family: Gentona, Arial, Helvetica, sans-serif !important;
            font-size: 14.44px !important;
            font-weight: bold !important;
            letter-spacing: 1.25px !important;
        }

        &__popupclose_btn {
            border-radius: 4px !important;
            color: $ypo-gray-text !important;
            font-family: Gentona, Arial, Helvetica, sans-serif !important;
            font-size: 15.44px !important;
            font-weight: 600 !important;
            letter-spacing: 1.25px !important;
            line-height: 16px !important;
            text-align: center !important;
        }

        &__icon-button {
            position: absolute;
            z-index: 100;

            &-edit {
                top: -20px;
                right: -30px;
            }

            &-close {
                left: -30px;
                bottom: -20px;
            }

            &-add {
                position: relative !important;
            }
        }

        &__img-wrapper {
            position: absolute;
            top: 0;
            height: 100%;
            width: 100%;
        }

        &__order-buttom {
            margin-left: 80px;
        }

        &__add-button-message {
            margin-left: 50px;
            color: $ypo-gold;
        }

        @include breakpoint(md) {
            .v-card {
                max-width: 1600px;
                width: 1600px;
            }
        }
    }

    /* grid layout */
    /********************************/
    .vue-grid-layout {
        background: $white;
        width: 100%;
    }

    .vue-resizable-handle {
        z-index: 5001;
        position: relative;
        width: 20px;
        height: 20px;
        bottom: 0;
        right: 0;
        background-position: bottom right;
        padding: 0 3px 3px 0;
        background-repeat: no-repeat;
        background-origin: content-box;
        box-sizing: border-box;
        cursor: se-resize;
    }

    .vue-grid-item:not(.vue-grid-placeholder) {
        background: $white;
        border: 1px solid $white;
    }

    .vue-grid-item.resizing {
        opacity: 0.9;
    }

    .vue-grid-item.static {
        background: $white;
    }

    .vue-grid-item .add {
        cursor: pointer;
    }
</style>
